import * as React from 'react';
import { ReactNode, Fragment } from 'react';
import {
  IconListContainer,
  IconListItemConnector,
  IconListItemContainer,
  IconListItemIcon,
  IconListItemIconWrapper,
  IconListItemText
} from './IconList.elements';

export interface IconNode {
  icon: ReactNode;
  text: string|React.ReactElement;
}

export interface IconListProps {
  data: IconNode[];
  iconSize?: number;
  fontSize?: number;
  fontSizeMobile?: number;
  fontNorm?: number;
  showIconsConnected?: boolean;
  minWidth?: string;
  marginLeftText?: string;
}

export const IconList: React.FunctionComponent<IconListProps> = ({
  data,
  iconSize,
  fontSize,
  fontSizeMobile,
  fontNorm,
  showIconsConnected,
  minWidth,
  marginLeftText,
}) => (
  <IconListContainer minWidth={minWidth}>
    { data.map((node, idx) =>
      <Fragment key={idx}>
        <IconListItemContainer showIconsConnected={showIconsConnected}>
          <IconListItemIconWrapper>
            <IconListItemIcon
              iconSize={iconSize}
            >
              { node.icon }
            </IconListItemIcon>
            { showIconsConnected && (idx !== (data.length - 1)) && (
              <IconListItemConnector>&nbsp;</IconListItemConnector>
            )}
          </IconListItemIconWrapper>
          <IconListItemText
            fontSize={fontSize}
            fontSizeMobile={fontSizeMobile}
            fontNorm={fontNorm}
            marginLeft={marginLeftText}
          >
            { node.text }
          </IconListItemText>
        </IconListItemContainer>
      </Fragment>
    )}
  </IconListContainer>
);
